import { useEffect } from "react";

export default function useHandleBodyBackground(location) {
    const page = location.pathname;

    useEffect(() => {
        document.body.className = "";

        if (page === "/register" || page === "/login") {
            document.body.classList.add("auth");
        } else {
            document.body.classList.add("home");
        }

        return () => {
            document.body.className = "";
        };
    }, [page]);
}
